import { get, post, patch, delete as axiosDelete } from 'axios'
import _ from 'lodash'
import {
  // VIDEOS_ENDPOINT,
  HOME_PLAYLIST_ENDPOINT,
  HISTORY_ENDPOINT,
  RECOMMENDATION_USER,
  SEARCH_ENDPOINT,
  RECENT_SEARCH_ENDPOINT,
  SUBSCRIPTIONS_ENDPOINT,
  ORDER_ENDPOINT,
  PAYMENT_ENDPOINT,
  PAYMENT_MCBILL_ENDPOINT,
  PAYMENT_REFUND_ENDPOINT,
  PAYMENT_SUBSCRIPTION,
  CAMPAIGN_ENDPOINT,
  CAMPAIGN_POSITION_ENDPOINT,
  RECOMMENDATION,
  RECOMMENDATION_TOP_PICKS,
  POPULAR,
  ARTICLES_RECOMMENDED_ENDPOINT,
  ARTICLES_ENDPOINT,
  HOME_PLAYLIST_ENDPOINT_NOCACHE,
  VIDEOS_ENDPOINT_NOCACHE,
  NOTIFICATION_ENDPOINT,
  PARTNERS_ENDPOINT,
  CUT_PRICE_PROMO_ENDPOINT,
  VALIDATE_PROMO_ENDPOINT,
  PROFILE_ENDPOINT,
  VIDEOS_CHECK_PERMISSION,
  MAPPING_SUBSCRIPTION_ENDPOINT,
  MAPPING_SUBSCRIPTION_CATEGORIZED_ENDPOINT,
  METHOD_INSTRUCTIONS_ENDPOINT,
  SELECTED_ATTRIBUTES_ENDPOINT,
  GEOGUARD_ENDPOINT,
  SESSION_RESTRICTION_ENDPOINT,
  PROMO_DETAIL_ENDPOINT,
  CHECK_BANNED_ENDPOINT,
  QUIZ_ENDPOINT,
  LANDINGPAGE_SUBSCRIBE_ENDPOINT,
  HISTORY_ORDER_ENDPOINT,
  INBOX_ENDPOINT,
  FINGERPRINT_ENDPOINT,
  TEAM_ENDPOINT,
  STATISTICS_STANDINGS_ENDPOINT,
  VIDEO_DIAGNOSTIC_ENDPOINT,
  USER_SUBSCRIPTION,
  USER_SUBSCRIPTIONS,
  ADD_DEVICE_ENDPOINT,
  MOLA_HUB_ENDPOINT,
} from './endpoints'
import utils from './util'

import { endpoints } from '@source/config'

const app_id = 'molatv'

const getHomePlaylist = ({ platformId }) => {
  return get(`${HOME_PLAYLIST_ENDPOINT_NOCACHE}/home-new`, {
    params: { platformId, app_id },
    ...endpoints.setting,
  })
    .then(response => {
      const data = _.get(response, 'data.data', []),
        pageStyle = _.get(data, '[0].attributes.pageStyle', ''),
        seo = _.get(data, '[0].attributes.seo', null),
        title = _.get(data, '[0].attributes.title', null)

      const result = utils.normalizeHomePlaylist(response)
      return {
        meta: {
          status: result[0].length > 0 ? 'success' : 'no_result',
          error: '',
          pageStyle,
          seo,
          title,
        },
        data: [...result[0]] || [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Home')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getFeaturePlaylist = ({ id, platformId }) => {
  return get(`${HOME_PLAYLIST_ENDPOINT_NOCACHE}/${id}`, {
    params: { platformId, app_id },
    ...endpoints.setting,
  })
    .then(response => {
      const data = _.get(response, 'data.data', []),
        id = _.get(data, '[0].id', ''),
        type = _.get(data, '[0].type', ''),
        title = _.get(data, '[0].attributes.title', ''),
        visibility = _.get(data, '[0].attributes.visibility', 0),
        playlists = _.get(data, '[0].attributes.playlists', []),
        menuId = _.get(data, '[0].attributes.menuId', ''),
        pageStyle = _.get(data, '[0].attributes.pageStyle', ''),
        seo = _.get(data, '[0].attributes.seo', null)

      const playlistsFiltered =
        playlists.length > 0
          ? playlists
            .map(playlist => ({
              id: playlist.id,
              type: playlist.type,
              ...playlist.attributes,
              // shortDescription: playlist.attributes.shortTitle,
            }))
            .filter(playlist => playlist.visibility === 1)
          : []
      return {
        meta: {
          status: data.length > 0 ? 'success' : 'no_result',
          error: '',
          id,
          title,
          type,
          visibility,
          menuId,
          pageStyle,
          seo,
        },
        data: playlistsFiltered,
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Feature playlist')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getCampaignPosition = playlistId => {
  return axios
    .get(`${CAMPAIGN_POSITION_ENDPOINT}/${playlistId}`, {
      params: { app_id },
      ...endpoints.setting,
    })
    .then(response => {
      const data = _.get(response, 'data.data', []),
        positionId = _.get(data, '[0].attributes.positionId', ''),
        positionName = _.get(data, '[0].attributes.positionName', '')
      return {
        meta: {
          status: data.length > 0 ? 'success' : 'no_result',
          error: '',
        },
        data: { positionId, positionName },
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Home')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getFeatureBanner = ({ id = '', platformId }) => {
  /* fid's are epl, sports, movies, kids */
  const url = id /* mobile-featured, desktop-featured, mobile-sport-featured, desktop-sport-featured, landing-page-${fid} */
  return get(`${CAMPAIGN_ENDPOINT}/${url}`, {
    params: { platformId, app_id, include: 'banners' },
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeFeatureBanner(response)
      return {
        meta: {
          status: result[0].length > 0 ? 'success' : 'no_result',
          error: '',
        },
        data: [...result[0]] || [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Home')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getLeaguesList = ({ id = 'leagues', platformId }) => {
  // link lama: genre-spo change into leagues
  return get(`${HOME_PLAYLIST_ENDPOINT}/league-list`, {
    params: { id, platformId },
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeLeagueList(response)
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: '',
        },
        data: result || [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Matches')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getMatchesPlaylists = ({ ids, startDate, endDate, platformId }) => {
  return get(`${HOME_PLAYLIST_ENDPOINT}/league-list/matches`, {
    params: {
      from: startDate,
      to: endDate,
      ids,
      summary: 1,
      platformId,
    },
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeMatchPlaylists(response)
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: '',
        },
        data: result || null,
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error: Mola Matches List')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getPlaylistPlaylists = ({ id, platformId }) => {
  return get(`${HOME_PLAYLIST_ENDPOINT_NOCACHE}/${id}`, {
    params: { platformId, app_id },
    ...endpoints.setting,
  })
    .then(response => {
      const data = _.get(response, 'data.data', []),
        description = _.get(data, '[0].attributes.description', ''),
        shortDescription = _.get(data, '[0].attributes.shortDescription', ''),
        background = _.get(data, '[0].attributes.images.cover.landscape', ''),
        forceChildStyle = _.get(data, '[0].attributes.forceChildStyle', null),
        playlists = _.get(data, '[0].attributes.playlists', ''),
        title = _.get(data, '[0].attributes.title', ''),
        menuId = _.get(data, '[0].attributes.menuId', ''),
        contentType = _.get(data, '[0].attributes.contentType', ''),
        pageStyle = _.get(data, '[0].attributes.pageStyle', ''),
        isSeason = _.get(data, '[0].attributes.isSeason', ''),
        isSeries = _.get(data, '[0].attributes.isSeries', ''),
        seo = _.get(data, '[0].attributes.seo', null)

      let playlistsFiltered = []
      if (playlists) {
        playlistsFiltered =
          playlists.length > 0
            ? playlists
              .map(dt => {
                return {
                  id: dt.id,
                  type: dt.type,
                  background: _.get(dt, 'attributes.images.cover.portrait', ''),
                  // shortDescription: _.get(dt, 'attributes.shortDescription', ''),
                  ...dt.attributes,
                }
              })
              .filter(dt => dt.visibility === 1)
            : []
      } else {
        playlistsFiltered =
          data.length > 0
            ? data
              .map(dt => ({
                id: dt.id,
                type: dt.type,
                ...dt.attributes,
              }))
              .filter(dt => dt.visibility === 1)
            : []
      }

      return {
        meta: {
          id,
          background,
          title,
          description,
          shortDescription,
          status: playlistsFiltered.length > 0 ? 'success' : 'no_result',
          error: '',
          menuId,
          type: playlists ? 'seasonal' : 'default',
          contentType,
          pageStyle,
          forceChildStyle,
          isSeason,
          isSeries,
          seo,
        },
        data: playlistsFiltered || [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Home')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getAllHistory = ({ userId }) => {
  return get(`${HISTORY_ENDPOINT}/${userId}/videos/histories`, {
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeHistory(response)
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
        },
        data: [...result] || [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola History')
      return {
        meta: {
          status: 'error',
          text: errorMessage,
        },
        data: [],
      }
    })
}

const getSearchResult = ({ q, platformId }) => {
  return get(`${SEARCH_ENDPOINT}`, {
    params: { app_id: app_id, query: q, platform_id: platformId },
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeSearchResult(response)
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: '',
        },
        data: [...result] || [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Search Result')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getSearchSuggestion = ({ searchText }) => {
  return get(`${SEARCH_ENDPOINT}`, {
    params: { app_id: app_id, search: searchText },
    ...endpoints.setting,
  })
    .then(response => {
      const result = _.get(response, 'data.result', [])
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: '',
        },
        data: [...result] || [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Search Suggestion')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getRecentSearch = (sessionId, at) => {
  return get(`${RECENT_SEARCH_ENDPOINT}`, {
    params: { sessionId: sessionId },
    ...endpoints.setting,
    headers: at ? { Authorization: `Bearer ${at}` } : {},
  })
    .then(response => {
      const result = utils.normalizeRecentSearch(response)
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: '',
        },
        data: result.length > 0 ? [...result] : [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Recent Search')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const postRecentSearch = (sessionId, at, keyword) => {
  post(
    `${RECENT_SEARCH_ENDPOINT}?sessionId=${sessionId}&q=${keyword}`,
    {},
    {
      ...endpoints.setting,
      headers: at ? { Authorization: `Bearer ${at}` } : {},
    },
  )
    .then(result => {
      return {
        meta: {
          status: 'success',
          error: '',
        },
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Update Recent Search')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
      }
    })
}

const deleteRecentSearchAll = (sessionId, at) => {
  return axiosDelete(`${RECENT_SEARCH_ENDPOINT}?sessionId=${sessionId}`, {
    ...endpoints.setting,
    headers: at ? { Authorization: `Bearer ${at}` } : {},
  })
    .then(result => {
      return {
        meta: {
          status: 'success',
          error: '',
        },
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Removing All Recent Search')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
      }
    })
}

const deleteRecentSearch = (sessionId, at, keyword) => {
  return axiosDelete(`${RECENT_SEARCH_ENDPOINT}?sessionId=${sessionId}&q=${keyword}`, {
    ...endpoints.setting,
    headers: { Authorization: `Bearer ${at}` },
  })
    .then(result => {
      return {
        meta: {
          status: 'success',
          error: '',
        },
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Removing Recent Search')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
      }
    })
}

const getMovieDetail = ({ id }) => {
  return get(`${VIDEOS_ENDPOINT_NOCACHE}/${id}`, {
    params: { app_id },
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeVideoDetail(response)
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          menuId: _.get(result, '[0].menuId', null),
          error: '',
        },
        data: [...result] || [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Movie Detail')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
          errorCode: error.response ? error.response.status : 0,
        },
        data: [],
      }
    })
}

const getRecommendation = id => {
  return get(`${RECOMMENDATION}`, {
    params: {
      app_id: app_id,
      video_id: id,
    },
  })
    .then(response => {
      const result = utils.normalizeRecommendation(response)
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: '',
        },
        data: result || [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Recommendation')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getRecommendationTopPicks = id => {
  return get(`${RECOMMENDATION_TOP_PICKS}`, {
    params: {
      app_id: app_id,
      video_id: id,
    },
  })
    .then(response => {
      const result = utils.normalizeRecommendation(response)
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: '',
        },
        data: result || [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Recommendation')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getPopular = id => {
  return get(`${POPULAR}`, {
    params: {
      app_id: app_id,
      video_id: id,
    },
  })
    .then(response => {
      const result = utils.normalizeRecommendation(response)
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: '',
        },
        data: result || [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Popular')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getSubscriptionById = (subsId, platformId, token) => {
  const errorPayload = {
    meta: {
      status: 'error',
      error: 'Wrong Subscriptions',
    },
    data: {},
  }
  const requestHeaders = {
    Authorization: `Bearer ${token}`,
  }
  return get(`${SUBSCRIPTIONS_ENDPOINT}/${subsId}`, {
    headers: requestHeaders,
    params: {
      app_id,
      platformId: platformId,
    },
    ...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      // console.log('masuk error', error)
      errorPayload.error = error
      return errorPayload
    })
}

const getAllSubscriptions = (token, platformId, videoId, playlistId, subsId) => {
  const isHasSubsId = !!subsId
  // version 2 or 1
  let URL_SUBSCRIPTIONS = SUBSCRIPTIONS_ENDPOINT
  const requestHeaders = {
    Authorization: `Bearer ${token}`,
  }
  const requestParams = {
    app_id: 'molatv',
  }

  if (!token) {
    delete requestHeaders.Authorization
  }
  // add params request to old version
  if (!isHasSubsId) {
    requestParams.platformId = platformId
    requestParams.videoId = videoId
    requestParams.playlistId = playlistId
  }

  // add params request to new version (aka: version 2)
  if (isHasSubsId) {
    requestParams.platformId = platformId
    requestParams.subsIds = subsId
  }

  return get(`${URL_SUBSCRIPTIONS}`, {
    headers: requestHeaders,
    params: requestParams,
    ...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola All Subscriptions')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const createOrder = ({
  token,
  uid,
  subscriptionId,
  price,
  uom,
  quantity,
  package_expiry,
  promo_code,
  payment_amount,
  total_price,
  order_type_id = 1,
  source = 'Mola',
}) => {
  var formData = new FormData()
  formData.set('order_type_id', order_type_id) //@TODO dynamic kalo form mps
  formData.set('order_status', 0)
  formData.set('source', source)
  formData.set('payment_method_id', 19)
  formData.set('order_amount', 1)
  formData.set('subscription_id', subscriptionId)
  formData.set('uom', uom)
  formData.set('quantity', quantity)
  formData.set('total_price', price)
  formData.set('user_id', uid)
  formData.set('package_expiry', package_expiry)
  formData.set('promo_code', promo_code)
  formData.set('payment_amount', payment_amount)
  formData.set('total_price', total_price)

  return post(`${ORDER_ENDPOINT}/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
    ...endpoints.setting,
  })
    .then(response => {
      const { data } = response.data
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: {
          id: data[0].id,
          ...data[0].attributes,
        },
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error,
        },
        data: [],
      }
    })
}

const createMidtransPayment = ({ token, orderId }) => {
  const data = JSON.stringify({
    payment_method_id: 277, // payment_method_id midtrans di hardcode 17 dari DataBase
    id: `${orderId}`,
  })

  return post(`${PAYMENT_ENDPOINT}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
    ...endpoints.setting,
  })
    .then(response => {
      const { paymentData } = response.data
      // const redirectUrl = `${endpoints.domain}/accounts/profile`
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: { ...paymentData },
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Midtrans Payment')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: '',
      }
    })
}

const createDopayPayment = ({
  token,
  orderId,
  payment_method_id,
  total_price = 0,
  quantity = 1,
  paymentInfo = '',
  userID = '',
  phone = '',
  mobilePhone = '',
  email = '',
  name = '',
  country = 'ID',
  currency = 'IDR',
  language = 'en',
}) => {
  const data = JSON.stringify({
    payment_method_id: payment_method_id,
    id: `${orderId}`,
    total_price: total_price,
    quantity: quantity,
    paymentInfo: paymentInfo,
    userID: userID,
    phone: phone,
    mobilePhone: mobilePhone,
    email: email,
    name: name,
    country: country,
    currency: currency,
    language: language,
  })

  return post(`${PAYMENT_ENDPOINT}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
    ...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: { ...response.data },
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error,
        },
        data: '',
      }
    })
}

const createMCBillPayment = ({ token, orderId, amount, paymentInfo, customerInfo }) => {
  const data = JSON.stringify({
    paymentMethod: 'va',
    paymentChannel: 'VA_BCA',
    amount: amount,
    // paymentInfo: `Order #${orderId}`,
    paymentInfo: paymentInfo,
    customerInfo: customerInfo,
    orderID: `${orderId}`,
  })

  return post(`${PAYMENT_MCBILL_ENDPOINT}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
    ...endpoints.setting,
  })
    .then(response => {
      // const redirectUrl = `${endpoints.domain}/accounts/profile`
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: { ...response.data },
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola MCBill Payment')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: '',
      }
    })
}

// const getOrderHistoryTransactions = ({ uid, token }) => {
//   // console.log('token', token)
//   return get(`${ORDER_ENDPOINT}_/users/${uid}`, {
//     headers: token && { Authorization: `Bearer ${token}` },
//     withCredentials: true,
//     ...endpoints.setting,
//   })
//     .then(response => {
//       const { data } = response.data
//       return {
//         meta: {
//           status: 'success',
//           error: '',
//         },
//         data,
//       }
//     })
//     .catch(error => {
//       const errorMessage = error.toString().replace('Error:', 'Mola History Transactions')
//       return {
//         meta: {
//           status: 'error',
//           error: errorMessage,
//         },
//         data: [],
//       }
//     })
// }

const getMappingCategorizedSubscriptions = ({ subscription_id, token, platformId = 1 }) => {
  return get(`${MAPPING_SUBSCRIPTION_CATEGORIZED_ENDPOINT}/${subscription_id}?platform_id=${platformId}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeMappingCategorizedSubscription(response)

      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: result || [],
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error,
        },
      }
    })
}

const getMappingSubscriptions = ({ subscription_id, token, platformId = 1 }) => {
  return get(`${MAPPING_SUBSCRIPTION_ENDPOINT}/${subscription_id}?platform_id=${platformId}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeMappingSubscription(response)
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: result || [],
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error,
        },
      }
    })
}

const getMethodInstructions = ({ payment_method_id, token }) => {
  return get(`${METHOD_INSTRUCTIONS_ENDPOINT}/${payment_method_id}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
    ...endpoints.setting,
  })
    .then(response => {
      const result = response.data
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: result || [],
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error,
        },
      }
    })
}

const getNotifications = (limit = 5, time = '') => {
  // console.log('JALAN HANDLER', `${NOTIFICATION_ENDPOINT}/in-app?app_id=molatv&limit=${limit}&time=${time}`)
  return get(`${NOTIFICATION_ENDPOINT}/in-app`, {
    params: {
      app_id,
      limit,
      time,
    },
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeNotifications(response)
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: result || [],
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.toString(),
        },
      }
    })
}

const getTotalNotifications = () => {
  // console.log('JALAN HANDLER', NOTIFICATION_ENDPOINT)
  return get(`${NOTIFICATION_ENDPOINT}/total`, { ...endpoints.setting })
    .then(response => {
      const { data } = response.data
      const { total } = data.attributes
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: total || 0,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error.toString(),
        },
      }
    })
}

const getRecommendedArticles = articlesId => {
  return get(`${ARTICLES_RECOMMENDED_ENDPOINT}/${articlesId}`, {
    ...endpoints.setting,
  })
    .then(response => {
      const data = _.get(response, 'data.data', {}),
        title = _.get(data, 'attributes.title', ''),
        articles = _.get(data, 'attributes.articles', [])

      const articlesFiltered =
        articles.length > 0
          ? articles.map(article => ({
            id: article.id,
            type: article.type,
            ...article.attributes,
          }))
          : []

      return {
        meta: {
          status: articlesFiltered.length > 0 ? 'success' : 'no_result',
          title,
          error: '',
        },
        data: articlesFiltered,
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Articles')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getArticlesDetail = articleId => {
  return get(`${ARTICLES_ENDPOINT}/${articleId}`, {
    ...endpoints.setting,
  })
    .then(response => {
      if (response.status === 200) {
        const result = utils.normalizeArticles(response)
        return {
          meta: {
            status: 'success',
          },
          data: result,
        }
      } else {
        return {
          meta: {
            status: 'error',
            error: `Mola Articles request failed with status ${response.status}`,
          },
          data: [],
        }
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Articles')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getArticlesList = query => {
  return get(`${ARTICLES_ENDPOINT}`, {
    params: {
      app_id: app_id,
      ...query,
    },
    ...endpoints.setting,
  })
    .then(response => {
      if (response.status === 200) {
        const result = utils.normalizeArticlesList(response)
        return {
          meta: {
            status: 'success',
          },
          data: result,
        }
      } else {
        return {
          meta: {
            status: 'error',
            error: `Mola Articles request failed with status ${response.status}`,
          },
          data: [],
        }
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Articles')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getPartners = () => {
  return get(`${PARTNERS_ENDPOINT}`, {
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizePartners(response)
      return {
        meta: {
          status: 'success',
        },
        data: result,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
        data: [],
      }
    })
}

const getApiPromoValidate = voucher => {
  // console.log('ini subscription', token)
  return get(`${VALIDATE_PROMO_ENDPOINT}/${voucher}`, {
    ...endpoints.setting,
    params: { app_id: app_id },
  })
    .then(response => {
      return response
    })
    .catch(error => {
      // console.log('masuk error', error)
      throw new Error(error)
    })
}

const getUserProfile = at => {
  return get(`${PROFILE_ENDPOINT}`, {
    ...endpoints.setting,
    headers: { Authorization: `Bearer ${at}`, 'x-app-id': 2 },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
        data: {},
      }
    })
}

const getVUID = ({ deviceId, r }) => {
  return axios
    .get(`${ADD_DEVICE_ENDPOINT}`, {
      timeout: 15000,
      params: {
        deviceId,
        r,
        test: 1,
      },
    })
    .then(response => {
      const vuid = _.get(response, 'data.data.attributes.vuid', null)
      return vuid
    })
    .catch(error => {
      console.log(error)
      return null
    })
}

const getVideoCheckPermission = ({ id, token, platformId }) => {
  return get(`${VIDEOS_CHECK_PERMISSION}/${id}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    params: { app_id, platformId },
    ...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
        data: {},
      }
    })
}

const getGeoguardData = (id, token) => {
  return get(`${GEOGUARD_ENDPOINT}/${id}`, {
    ...endpoints.setting,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
        data: {},
      }
    })
}

const getVpnWhitelisting = (uid, vuid, ip, videoId) => {
  // console.log('iniid', vuid)
  return get(`${VIDEOS_ENDPOINT_NOCACHE}/whitelists`, {
    ...endpoints.setting,
    headers: { 'Content-Type': 'application/json' },
    params: {
      userId: uid,
      deviceId: vuid,
      videoId,
      ip,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      // console.log('masuk error', error)
      const errorMessage = error.toString().replace('Error:', 'Get VPN Whitelisting')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: {},
      }
    })
}

const checkSessionRestricted = (id, token) => {
  return post(
    `${SESSION_RESTRICTION_ENDPOINT}`,
    { session_id: id, simulateFail: 0 },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      ...endpoints.setting,
    },
  )
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: _.get(response, 'data.data', {}),
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
        data: {},
      }
    })
}

const checkUserBanned = (sessionId, token) => {
  const sessionid = sessionId ? sessionId : ''
  const headers = { 'Content-Type': 'application/json' }
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }
  return get(`${CHECK_BANNED_ENDPOINT}`, {
    ...endpoints.setting,
    headers,
    params: {
      app_id,
      sessionId: sessionid,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
        data: {},
      }
    })
}

const getFingerprint = (sessionId, token) => {
  const sessionid = sessionId ? sessionId : ''
  const headers = { 'Content-Type': 'application/json' }
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }
  return get(`${FINGERPRINT_ENDPOINT}`, {
    ...endpoints.setting,
    headers,
    params: {
      app_id,
      text: sessionid,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
        data: {},
      }
    })
}

const getSelectedAttributes = (id, attributes) => {
  return get(`${SELECTED_ATTRIBUTES_ENDPOINT}/${id}`, {
    ...endpoints.setting,
    params: {
      app_id,
      attribute: attributes,
    },
  })
    .then(response => {
      const result = utils.normalizeSelectedAttributes(response)
      return {
        meta: {
          status: 'success',
        },
        data: result,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
        data: [],
      }
    })
}

const getPromoCutPrice = (voucherCode, amount, token, subsId) => {
  return get(`${CUT_PRICE_PROMO_ENDPOINT}/${voucherCode}/${amount}?subsId=${subsId}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
    ...endpoints.setting,
  })
    .then(response => {
      const result = response.data
      return {
        meta: {
          status: Object.keys(result).length > 0 ? 'success' : 'no_result',
          error: '',
        },
        data: { ...result } || {},
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
        data: {},
      }
    })
}

const getPromoList = id => {
  return get(`${PROMO_DETAIL_ENDPOINT}/${id}`, {
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizePromoList(response)
      return {
        data: result,
        meta: {
          status: 'success',
        },
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
        data: {},
      }
    })
}

const getPromoDetail = id => {
  return get(`${PROMO_DETAIL_ENDPOINT}/${id}`, {
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizePromoDetail(response)
      return {
        meta: {
          status: 'success',
        },
        data: result,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
        data: {},
      }
    })
}

const insertUserLanguage = async ({ token, language }) => {
  return await post(
    `${HISTORY_ENDPOINT}/preferences/language`,
    {
      language,
    },
    {
      params: { app_id },
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      ...endpoints.setting,
    },
  )
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
      }
    })
}

const getUserLanguage = async token => {
  return await get(`${HISTORY_ENDPOINT}/preferences/language`, {
    params: { app_id },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    ...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
        data: _.get(response, 'data.data.attributes.language', ''),
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
      }
    })
}

const deleteUserLanguage = async token => {
  return await axiosDelete(`${HISTORY_ENDPOINT}/preferences/language`, {
    params: { app_id },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    ...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
      }
    })
}

const getContinueWatching = ({ token, platformId }) => {
  return get(`${HISTORY_ENDPOINT}/history`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    params: { platformId },
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeContinueWatching(response)
      return {
        meta: {
          status: 'success',
          id: 'resume-vid',
          sortOrder: 1.5,
          contentType: 9,
        },
        data: result,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
        data: [],
      }
    })
}

const getRecommendationUser = ({ uid }) => {
  return get(`${RECOMMENDATION_USER}`, {
    params: { app_id, user_id: uid },
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeRecommendationUser(response)
      return {
        meta: {
          status: 'success',
        },
        data: result,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
        data: [],
      }
    })
}

const createResumeVideo = async (payload, token) => {
  return await post(`${HISTORY_ENDPOINT}/history`, payload, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    ...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
      }
    })
}

const deleteResumeVideo = async (videoId, token) => {
  return await axiosDelete(`${HISTORY_ENDPOINT}/history`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    data: {
      videoID: videoId,
    },
    ...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
        },
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
      }
    })
}

const getUserRefundDetail = ({ token, email }) => {
  return get(`${PAYMENT_REFUND_ENDPOINT}/detail/email/${email}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    params: { app_id },
    ...endpoints.setting,
  })
    .then(response => {
      const data = _.get(response, 'data.data', [])

      // const redirectUrl = `${endpoints.domain}/accounts/profile`
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data:
          data.length > 0
            ? {
              id: data[0].id,
              ...data[0].attributes,
            }
            : {},
      }
    })
    .catch(error => {
      const errorMessage = error.toString()
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: '',
      }
    })
}

const submitRefundDetail = ({ token, params }) => {
  const data = JSON.stringify({
    bank: params.bank,
    accountNumber: params.accountNumber,
    accountHolder: params.accountHolder,
    bankBranch: params.bankBranch,
    phoneNumber: params.phoneNumber,
  })

  return post(`${PAYMENT_REFUND_ENDPOINT}/submit/${params.id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    params: { app_id },
    ...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString()
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: '',
      }
    })
}

const getOrderHistory = token => {
  return get(`${ORDER_ENDPOINT}/users?order=desc`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeOrderHistory(response.data)
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: result || [],
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error,
        },
      }
    })
}

const getOrderHistoryById = ({ token, orderId }) => {
  return get(`${HISTORY_ORDER_ENDPOINT}/${orderId}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeOrderHistoryById(response.data)

      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: result || {},
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error,
        },
      }
    })
}

const getBulkSubscriptionDetailById = (ids, token) => {
  const data = ids
  return post(`${SUBSCRIPTIONS_ENDPOINT}/ids`, data, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeSubscriptionDetail(response.data)

      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: result || [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Subscription Data')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: '',
      }
    })
}

const getBannerSubscribePage = ({ platformId }) => {
  // return get(`${CAMPAIGN_ENDPOINT}/landing-page-subscribe?include=banners`, {
  return get(`${CAMPAIGN_ENDPOINT}/landing-page-subscribe`, {
    params: { platformId, include: 'banners' },
    ...endpoints.setting,
  })
    .then(response => {
      const result = _.get(response, 'data.data[0].attributes.banners', [])
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: '',
        },
        data: result.length > 0 ? [...result] : [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Banner Subscription Data')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: '',
      }
    })
}

const getInbox = (params = {}, token) => {
  return get(`${INBOX_ENDPOINT}/inbox`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    ...endpoints.setting,
    params: {
      ...params,
      app_id: app_id,
    },
  })
    .then(response => {
      const result = utils.normalizeInboxList(response)
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: '',
        },
        data: result.length > 0 ? [...result] : [],
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Inbox Error')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getInboxDetail = (params = {}, token) => {
  const inboxId = _.get(params, 'inboxId', '')
  return get(`${INBOX_ENDPOINT}/inbox/${inboxId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    ...endpoints.setting,
    params: {
      ...params,
      app_id: app_id,
    },
  })
    .then(response => {
      const result = utils.normalizeInboxDetail(response)
      return {
        meta: {
          status: result ? 'success' : 'no_result',
          error: '',
        },
        data: result,
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Inbox detail Error')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: null,
      }
    })
}

const getInboxCategory = () => {
  return get(`${INBOX_ENDPOINT}/categories`, {
    params: {
      app_id: app_id,
    },
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeInboxCategory(response)
      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
          error: '',
        },
        data: result,
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Inbox Category Error')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getPlaylistChild = ({ id, platformId }) => {
  return get(`${HOME_PLAYLIST_ENDPOINT_NOCACHE}/${id}`, {
    params: { platformId, app_id },
    ...endpoints.setting,
  })
    .then(response => {
      const data = _.get(response, 'data.data', []),
        playlists = _.get(data, '[0].attributes.playlists', ''),
        videos = _.get(data, '[0].attributes.videos', '')
      let playlistsFiltered = []
      if (playlists) {
        playlistsFiltered =
          playlists.length > 0
            ? playlists
              .map(dt => {
                return {
                  id: dt.id,
                  type: dt.type,
                  background: _.get(dt, 'attributes.images.cover.background', { portrait: null, landscape: null }),
                  ...dt.attributes,
                  // shortDescription: dt.attributes.shortDescription,
                }
              })
              .filter(dt => dt.visibility === 1)
            : []
        return {
          meta: {
            status: 'success',
            error: '',
            type: 'playlists',
          },
          data: playlistsFiltered || [],
        }
      } else if (videos) {
        const result = utils.normalizeHomeVideo(response)
        return {
          meta: {
            status: 'success',
            error: '',
            type: 'videos',
          },
          data: [...result[0]] || [],
        }
      } else {
        return {
          meta: {
            status: 'no_result',
            error: '',
            type: 'videos',
          },
          data: [],
        }
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Home')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: [],
      }
    })
}

const getCounterInbox = token => {
  return get(`${INBOX_ENDPOINT}/counter`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      app_id: app_id,
    },
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeCounterInbox(response)
      return {
        meta: {
          status: result ? 'success' : 'no_result',
          error: '',
        },
        data: result,
      }
    })
    .catch(err => {
      const errorMessage = error.toString().replace('Error:', 'Mola Inbox Counter Error')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
      }
    })
}

const getStandingsTeam = payload => {
  return post(
    `${TEAM_ENDPOINT}`,
    {
      ...payload,
    },
    {
      ...endpoints.setting,
    },
  )
    .then(response => {
      const result = utils.normalizeStandingsTeam(response)
      return {
        meta: {
          status: result ? 'success' : 'no_result',
          error: '',
        },
        data: result,
      }
    })
    .catch(err => {
      const errorMessage = error.toString().replace('Error:', 'Mola Standings Error')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
      }
    })
}

const getStatisticsStandings = () => {
  return get(`${STATISTICS_STANDINGS_ENDPOINT}`, {
    ...endpoints.setting,
  })
    .then(response => {
      const result = _.get(response, 'data.data', null)
      return {
        meta: {
          status: result ? 'success' : 'no_result',
          error: '',
        },
        data: result,
      }
    })
    .catch(error => {
      const errorMessage = error.toString().replace('Error:', 'Mola Statistics Standings Error')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
      }
    })
}

const getResumeVideo = (id = '', token = '') => {
  return get(`${HISTORY_ENDPOINT}/history/time-position/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    ...endpoints.setting,
  })
    .then(response => {
      const result = _.get(response, 'data.data.attributes.timePosition', 0)
      return result && result > 0 ? result.toString() : ''
    })
    .catch(error => {
      return ''
    })
}

const getReminders = (token, order) => {
  return get(`${HISTORY_ENDPOINT}/reminders`, {
    params: { app_id: app_id, order: order },
    headers: {
      Authorization: `Bearer ${token}`,
    },
    ...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'SUCCESS',
          error: '',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      // console.log(error, 'errorrrr')
      const errorMessage = error.toString().replace('Error:', 'Mola Reminder Error')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
      }
    })
}

const getReminder = (token, id) => {
  // console.log('jalannn')
  return get(`${HISTORY_ENDPOINT}/reminder/${id}`, {
    params: { app_id: app_id },
    headers: {
      Authorization: `Bearer ${token}`,
    },
    ...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'SUCCESS',
          error: '',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      // console.log(error, 'errorrrr')
      const errorMessage = error.toString().replace('Error:', 'Mola Reminder Error')
      return {
        meta: {
          status: 'ERROR',
          error: errorMessage,
        },
      }
    })
}

const postReminder = (token, id) => {
  return post(
    `${HISTORY_ENDPOINT}/reminder/${id}`,
    {},
    {
      params: { app_id: app_id },
      headers: {
        Authorization: `Bearer ${token}`,
      },
      ...endpoints.setting,
    },
  )
    .then(response => {
      return {
        meta: {
          status: 'SUCCESS',
          error: '',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      // console.log(error, 'errorrrr')
      const errorMessage = error.toString().replace('Error:', 'Mola Reminder Error')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
      }
    })
}

const deleteReminder = (token, id) => {
  return axios
    .delete(`${HISTORY_ENDPOINT}/reminder/${id}`, {
      params: { app_id: app_id },
      headers: {
        Authorization: `Bearer ${token}`,
      },
      ...endpoints.setting,
    })
    .then(response => {
      return {
        meta: {
          status: 'SUCCESS',
          error: '',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      // console.log(error, 'errorrrr')
      const errorMessage = error.toString().replace('Error:', 'Mola Reminder Error')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
        data: null,
      }
    })
}

const getBatchReminder = (token, ids) => {
  return post(
    `${HISTORY_ENDPOINT}/reminders`,
    {
      videos: ids,
    },
    {
      params: { app_id: app_id },
      headers: {
        Authorization: `Bearer ${token}`,
      },
      ...endpoints.setting,
    },
  )
    .then(response => {
      let result = utils.normalizeBatchReminders(response)
      return {
        meta: {
          status: 'SUCCESS',
          error: '',
        },
        data: result,
      }
    })
    .catch(error => {
      let errorStatus = ''
      if (error.response) {
        errorStatus = error.response.status
      }
      const errorMessage = error.toString().replace('Error:', 'Mola Reminder Error')
      return {
        meta: {
          status: 'ERROR',
          error: errorMessage,
          errorStatus: errorStatus,
        },
        data: [],
      }
    })
}

const getVideoDiagnostic = url => {
  return get(`${VIDEO_DIAGNOSTIC_ENDPOINT}?url=${url}`, {
    ...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error,
        },
      }
    })
}

const endRecurring = (token, subscriptionId) => {
  return patch(
    `${USER_SUBSCRIPTIONS}/${subscriptionId}/recurring/end`,
    {},
    {
      ...endpoints.setting,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )
    .then(response => {
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
      }
    })
}

const getSubscriptionsById = (token, subscriptionId) => {
  return get(
    `${USER_SUBSCRIPTION}/${subscriptionId}`,
    {
      ...endpoints.setting,
      params: { app_id: app_id },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )
    .then(response => {
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
      }
    })
}

const getOrderDetail = (token, orderId) => {
  return get(`${ORDER_ENDPOINT}/${orderId}`, {
    ...endpoints.setting,
    params: { app_id: app_id },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
      }
    })
}

const getPaymentDetailSubscription = (token, orderId) => {
  return get(`${PAYMENT_SUBSCRIPTION}/payment-detail/${orderId}`, {
    ...endpoints.setting,
    params: { app_id: app_id },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: response.data,
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error,
        },
      }
    })
}

const getFavorite = (order, token) => {
  return get(`${HISTORY_ENDPOINT}/user-favorite`, {
    params: { app_id: app_id, order: order },
    headers: {
      Authorization: `Bearer ${token}`,
    },
    ...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'SUCCESS',
          error: '',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      // console.log(error, 'errorrrr')
      const errorMessage = error.toString().replace('Error:', 'Mola Favorite Error')
      return {
        meta: {
          status: 'error',
          statusError: '',
          error: errorMessage,
        },
      }
    })
}

const checkFavorite = (id, type, token) => {
  return get(`${HISTORY_ENDPOINT}/user-favorite/${id}`, {
    params: { app_id: app_id, favoriteType: type },
    headers: {
      Authorization: `Bearer ${token}`,
    },
    ...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'SUCCESS',
          error: '',
        },
        data: response.data.data,
      }
    })
    .catch(error => {
      // console.log(error, 'errorrrr')
      const errorMessage = error.toString().replace('Error:', 'Mola Favorite Error')
      return {
        meta: {
          status: 'error',
          statusError: '',
          error: errorMessage,
        },
      }
    })
}

const addFavorite = (id, type, token) => {
  return post(
    `${HISTORY_ENDPOINT}/user-favorite`,
    {
      refID: id,
      favoriteType: type,
    },
    {
      params: { app_id: app_id },
      headers: {
        Authorization: `Bearer ${token}`,
      },
      ...endpoints.setting,
    },
  )
    .then(response => {
      return {
        meta: {
          status: 'SUCCESS',
          error: '',
        },
      }
    })
    .catch(error => {
      // console.log(error, 'errorrrr')
      const errorMessage = error.toString().replace('Error:', 'Mola Reminder Error')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
      }
    })
}

const deleteFavorite = (id, type, token) => {
  return axiosDelete(`${HISTORY_ENDPOINT}/user-favorite`, {
    params: { app_id: app_id },
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      refID: id,
      favoriteType: type,
    },
    ...endpoints.setting,
  })
    .then(response => {
      return {
        meta: {
          status: 'SUCCESS',
          error: '',
        },
      }
    })
    .catch(error => {
      // console.log(error, 'errorrrr')
      const errorMessage = error.toString().replace('Error:', 'Mola Reminder Error')
      return {
        meta: {
          status: 'error',
          error: errorMessage,
        },
      }
    })
}

const getallCities = () => {
  return get(`${ORDER_ENDPOINT}/cities`, {
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeGetAllCities(response)

      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
        },
        data: [...result] || [],
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error,
        },
        data: [],
      }
    })
}

const getDistrictByCityId = cityId => {
  return get(`${ORDER_ENDPOINT}/district/city/${cityId}`, {
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeGetDistrictByCityId(response)

      return {
        meta: {
          status: result.length > 0 ? 'success' : 'no_result',
        },
        data: [...result] || [],
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error,
        },
        data: [],
      }
    })
}

const postOrderDetail = (at, data) => {
  return post(`${ORDER_ENDPOINT}/orders-detail`, data, {
    ...endpoints.setting,
    headers: at
      ? {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${at}`,
      }
      : {},
  })
    .then(result => {
      return {
        meta: {
          status: 'success',
          error: '',
        },
        data: { ...result.data } || {},
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error,
        },
      }
    })
}

const getMolaHub = ({ playlistId = '', platformId = 7 }) => {
  return get(`${MOLA_HUB_ENDPOINT}/${playlistId}`, {
    params: {
      platformId,
    },
    ...endpoints.setting,
  })
    .then(response => {
      const result = utils.normalizeMolaHub(response)
      return {
        meta: {
          status: result ? 'success' : 'no_result',
          error: '',
        },
        data: { ...result } || {},
      }
    })
    .catch(error => {
      return {
        meta: {
          status: 'error',
          error: error,
        },
        data: {},
      }
    })
}

export default {
  getHomePlaylist,
  getFeaturePlaylist,
  getFeatureBanner,
  getAllHistory,
  getSearchResult,
  getSearchSuggestion,
  getRecentSearch,
  postRecentSearch,
  deleteRecentSearch,
  deleteRecentSearchAll,
  getMovieDetail,
  getRecommendation,
  getAllSubscriptions,
  getSubscriptionById,
  createOrder,
  createMidtransPayment,
  createDopayPayment,
  createMCBillPayment,
  getUserRefundDetail,
  submitRefundDetail,
  getLeaguesList,
  getMatchesPlaylists,
  getPlaylistPlaylists,
  getRecommendedArticles,
  getArticlesDetail,
  getArticlesList,
  getPartners,
  getNotifications,
  getMethodInstructions,
  getMappingSubscriptions,
  getMappingCategorizedSubscriptions,
  getTotalNotifications,
  getSelectedAttributes,
  getPromoDetail,
  getPromoCutPrice,
  getApiPromoValidate,
  getUserProfile,
  getVUID,
  getVideoCheckPermission,
  getGeoguardData,
  checkSessionRestricted,
  getPromoList,
  getRecommendationTopPicks,
  getPopular,
  insertUserLanguage,
  getUserLanguage,
  deleteUserLanguage,
  getContinueWatching,
  getRecommendationUser,
  createResumeVideo,
  deleteResumeVideo,
  checkUserBanned,
  getFingerprint,
  getVpnWhitelisting,
  getOrderHistory,
  getBulkSubscriptionDetailById,
  getBannerSubscribePage,
  getOrderHistoryById,
  getInbox,
  getInboxDetail,
  getInboxCategory,
  getPlaylistChild,
  getCounterInbox,
  getStandingsTeam,
  getStatisticsStandings,
  getResumeVideo,
  getCampaignPosition,
  getReminder,
  getReminders,
  postReminder,
  deleteReminder,
  getBatchReminder,
  getVideoDiagnostic,
  endRecurring,
  getSubscriptionsById,
  getFavorite,
  addFavorite,
  deleteFavorite,
  checkFavorite,
  getOrderDetail,
  getPaymentDetailSubscription,
  getallCities,
  getDistrictByCityId,
  postOrderDetail,
  getMolaHub,
}
